// Definición centralizada de endpoints de la API

const endpoints = {
  // Endpoints de calculadora ambiental
  calculator: {
    registrarContacto: '/calculadora-ambiental/contactos',
  },
};

export default endpoints;